(() => {
  const buttons = document.querySelectorAll('[data-pg-cookie-preferences]');
  function waitForBanner() {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const check = () => {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          resolve(window.privacyBanner);
        } else if (++attempts >= 40) {
          reject(new Error('Shopify cookie preferences unavailable'));
        } else {
          window.setTimeout(check, 100);
        }
      };
      check();
    });
  }
  buttons.forEach(button => {
    button.addEventListener('click', async () => {
      const status = button.parentElement.querySelector('[data-pg-cookie-preferences-status]');
      button.disabled = true;
      if (status) status.hidden = true;
      try {
        const banner = await waitForBanner();
        await banner.showPreferences();
      } catch (_) {
        if (status) {
          status.textContent = 'Preferințele nu pot fi încărcate momentan. Reîncarcă pagina și încearcă din nou.';
          status.hidden = false;
        }
      } finally {
        button.disabled = false;
      }
    });
  });
})();
